export function initialState() {
  return {phase:'locate', detail:null, feedback:null, screw:0, score:0, attempts:{overload:0, leakage:0}};
}
export function transition(state, action) {
  if (action.type === 'RESET') return initialState();
  if (['overload','leakage'].includes(state.phase)) {
    const correct = state.phase === 'overload' ? 'breaker' : 'differential';
    if (action.type === 'ANSWER' && ['breaker','differential'].includes(action.choice) && state.detail !== 'correct') {
      const attempts = {...state.attempts, [state.phase]:state.attempts[state.phase]+1};
      const ok = action.choice === correct;
      return {...state, attempts, detail:ok ? 'correct' : null, score:state.score+(ok && attempts[state.phase]===1 ? 1 : 0), feedback:ok ? 'correct'+(state.phase === 'overload' ? 'Overload' : 'Leakage') : 'wrong'+(state.phase === 'overload' ? 'Overload' : 'Leakage')};
    }
    if (action.type === 'CONTINUE' && state.detail === 'correct') return {...state,phase:state.phase==='overload'?'leakage':'complete',detail:null,feedback:null};
    return state;
  }
  const steps = {locate:['board','differential'], differential:['differential','breaker'], breaker:['breaker','diagram'], diagram:['diagram','tool']};
  const step = steps[state.phase];
  if (step && action.type === 'SELECT') {
    if (action.target === step[0]) return {...state, detail:step[0], feedback:null};
    return {...state, feedback:state.phase === 'differential' ? 'wrongDifferential' : 'wrongTarget'};
  }
  if (step && action.type === 'CONTINUE' && state.detail === step[0]) return {...state, phase:step[1], detail:null, feedback:null};
  if (state.phase === 'tool' && action.type === 'SELECT') {
    return action.target === 'screwdriver' ? {...state, phase:'fasten', feedback:'toolReady'} : {...state, feedback:'wrongTool'};
  }
  if (state.phase === 'fasten' && action.type === 'TURN' && Number.isFinite(action.delta) && action.delta > 0 && action.delta <= .1) {
    const screw = Math.min(1, state.screw + action.delta);
    return {...state, screw, phase:screw >= 1 ? 'overload' : 'fasten', feedback:screw >= 1 ? 'coverSecure' : null};
  }
  return state;
}
